export const DRMT_EXCEL_LABEL = [
  { label: "carrier_scac", key: "carrierScac", value: "carrierScac", name: "Carrier SCAC" },
  { label: "supplier", key: "supplier", value: "supplier", name: "Supplier" },
  { label: "service_scac", key: "serviceScac", value: "serviceScac", name: "Service SCAC" },
  { label: "equip_type", key: "equipmentType", value: "equipmentType", name: "Equipment Type" },
  { label: "mode_of_transport", key: "modeOfTransport", value: "modeOfTransport", name: "SAP Mode" },
  { label: "mode", key: "mode", value: "mode", name: "Mode" },

  { label: "tariff_number", key: "tariffNumber", value: "tariffNumber", name: "Tariff Number" },
  { label: "tariff_id", key: "tariffId", value: "tariffId", name: "Tariff ID" },

  { label: "effective_date", key: "effectiveDate", value: "effectiveDate", name: "Effective Date" },
  { label: "expiration_date", key: "expirationDate", value: "expirationDate", name: "Expiration Date" },

  { label: "item_type", key: "itemType", value: "itemType", name: "Item Type" },
  { label: "item", key: "item", value: "item", name: "Item" },

  { label: "region", key: "region", value: "region", name: "Region" },
  { label: "carrier_manager", key: "carrierManager", value: "carrierManager", name: "Carrier Manager" },
  { label: "trade_lane", key: "tradeLane", value: "tradeLane", name: "Trade Lane" },
  { label: "lane_description", key: "laneDescription", value: "laneDescription", name: "Lane Description" },
  { label: "incoterms", key: "incoterms", value: "incoterms", name: "Incoterms" },

  { label: "org_hub", key: "orgHub", value: "orgHub", name: "Origin Hub" },
  { label: "origin_zone", key: "originZone", value: "originZone", name: "Origin Zone" },
  { label: "origin_zone_desc", key: "originZoneDesc", value: "originZoneDesc", name: "Origin Zone Description" },
  { label: "origin_zone_short_desc", key: "originZoneShortDesc", value: "originZoneShortDesc", name: "Origin Zone Short Description" },
  { label: "origin_city", key: "originCity", value: "originCity", name: "Origin City" },
  { label: "origin_state", key: "originState", value: "originState", name: "Origin State" },
  { label: "origin_country", key: "originCountry", value: "originCountry", name: "Origin Country" },
  { label: "origin_postal_code", key: "originPostalCode", value: "originPostalCode", name: "Origin Postal Code" },

  { label: "dest_hub", key: "destHub", value: "destHub", name: "Destination Hub" },
  { label: "destination_zone", key: "destinationZone", value: "destinationZone", name: "Destination Zone" },
  { label: "destination_zone_desc", key: "destinationZoneDesc", value: "destinationZoneDesc", name: "Destination Zone Description" },
  { label: "destination_zone_short_desc", key: "destinationZoneShortDesc", value: "destinationZoneShortDesc", name: "Destination Zone Short Description" },
  { label: "destination_city", key: "destinationCity", value: "destinationCity", name: "Destination City" },
  { label: "destination_state", key: "destinationState", value: "destinationState", name: "Destination State" },
  { label: "destination_country", key: "destinationCountry", value: "destinationCountry", name: "Destination Country" },
  { label: "destination_postal_code", key: "destinationPostalCode", value: "destinationPostalCode", name: "Destination Postal Code" },

  { label: "lane_service_type", key: "laneServiceType", value: "laneServiceType", name: "Lane Service Type" },
  { label: "primary_customers", key: "primaryCustomers", value: "primaryCustomers", name: "Primary Customer(s)" },
  { label: "estimated_mileage_pc_miler", key: "miles", value: "miles", name: "Estimated Mileage - PC Miler" },
  // { label: "miles", key: "miles", value: "miles", name: "Miles" },

  { label: "line_haul_charge_type", key: "lineHaulChargeType", value: "lineHaulChargeType", name: "LineHaul Charge Type" },
  { label: "line_haul_rate", key: "lineHaulRate", value: "lineHaulRate", name: "LineHaul Rate" },
  // { label: "rate", key: "rate", value: "rate", name: "Rate" },
  { label: "btf_rate", key: "btfRate", value: "btfRate", name: "BTF Rate" },

  { label: "bid_rate_wo_fuel", key: "bidRateWoFuel", value: "bidRateWoFuel", name: "Bid Rate w/o Fuel" },

  { label: "baf_flat_type", key: "baf", value: "baf", name: "BAF - FLAT Type" },
  { label: "ets_flat_type", key: "ets", value: "ets", name: "ETS - FLAT Type" },
  { label: "civa_flat_type", key: "civa", value: "civa", name: "CIVA - FLAT Type" },

  { label: "annual_shipment_volume", key: "annualShipmentVolume", value: "annualShipmentVolume", name: "Annual Shipment Volume" },
  { label: "available_annual_shipment_volume", key: "availableAnnualShipmentVolume", value: "availableAnnualShipmentVolume", name: "Available Annual Shipment Volume" },
  { label: "annual_max_shipment_volume", key: "annualMaxShipmentVolume", value: "annualMaxShipmentVolume", name: "Annual Max Shipment Volume" },

  { label: "award_backup", key: "awardBackup", value: "awardBackup", name: "Award / Backup" },

  { label: "bucket_type", key: "bucketType", value: "bucketType", name: "Bucket Type" },
  { label: "qty_bucket_type", key: "qtyBucketType", value: "qtyBucketType", name: "Quantity Bucket Type" },
  { label: "pct_bucket_type", key: "pctBucketType", value: "pctBucketType", name: "Percentage Bucket Type" },

  { label: "qty_active_flag", key: "qtyActiveFlag", value: "qtyActiveFlag", name: "Qty Active Flag"},
  // { label: "qty_start_date", key: "qtyStartDate", value: "qtyStartDate", name: "Quantity Start Date" },
  // { label: "qty_end_date", key: "qtyEndDate", value: "qtyEndDate", name: "Quantity End Date" },

  { label: "min_shipments_allocated", key: "minShipmentsAllocated", value: "minShipmentsAllocated", name: "Min Shipments Allocated" },
  { label: "max_shipments_allocated", key: "maxShipmentsAllocated", value: "maxShipmentsAllocated", name: "Max Shipments Allocated" },

  { label: "pct_active_flag", key: "percentageActiveFlag", value: "percentageActiveFlag", name: "Percentage Active Flag" },
  // { label: "pct_start_date", key: "pctStartDate", value: "pctStartDate", name: "Percentage Start Date" },
  // { label: "pct_end_date", key: "pctEndDate", value: "pctEndDate", name: "Percentage End Date" },

  { label: "min_pct_constrain", key: "minCarrierAllocationPercentage", value: "minCarrierAllocationPercentage", name: "Min Carrier Allocation Percentage" },
  { label: "max_pct_constrain", key: "maxCarrierAllocationPercentage", value: "maxCarrierAllocationPercentage", name: "Max Carrier Allocation Percentage" },
  // { label: "pct_award", key: "pctAward", value: "pctAward", name: "Percentage Award" },

  { label: "order_type", key: "orderType", value: "orderType", name: "Order Type" },
  { label: "pre_awarded", key: "preAwarded", value: "preAwarded", name: "Pre-Awarded" },
  // { label: "status", key: "status", value: "status", name: "Status" },

  { label: "bid_file_name", key: "bidFileName", value: "bidFileName", name: "Bid File Name" },
  { label: "change_comment", key: "changeComment", value: "changeComment", name: "Change Comment" },

  { label: "record_errors", key: "coupaFileRecordErrors", value: "coupaFileRecordErrors", name: "Record Errors" },
  { label: "default_error", key: "defaultError", value: "defaultError", name: "Default Error" },

  { label: "user_id", key: "userId", value: "userId", name: "User ID" },
  { label: "created_date", key: "createdDate", value: "createdDate", name: "Created Date" },
  { label: "updated_date", key: "updatedDate", value: "updatedDate", name: "Updated Date" },
  { label: "message", key: "message", value: "message", name: "Status" },

  { label: "transit_time", key: "transitTime", value: "transitTime", name: "Transit Time" },

  { label: "system_rate_id", key: "systemRateId", value: "systemRateId", name: "Rate ID" },
];


